import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import Search from '../../../components/Search';
import Table from '../../../components/Table';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import {
  getTempTransactionList,
  deleteTempTransaction,
} from '../../../axios/TempTransactionAxios';
import LoadingOverlay from '../../../components/LoadingOverlay';

function TempTransactionList() {
  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Temporary Transaction' },
  ];

  const [tempTransaction, setTempTransaction] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);
  const [screenLoading, setScreenLoading] = useState(false);

  const navigation = useNavigate();

  const fetchTempTransactionList = async (keyword, page, limit) => {
    try {
      const result = await getTempTransactionList(keyword, page, limit);

      // Gabungkan business_code dan name menjadi satu properti baru
      const modifiedData = result.data.map((transaction) => ({
        ...transaction,
        businessUnit: `${transaction.business_unit.business_code} - ${transaction.business_unit.name}`, // Gabungkan business_code dan name
      }));

      // Set data yang sudah dimodifikasi
      setTempTransaction(modifiedData);
      setTotalPages(result.totalPages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTempTransactionList(searchKeyword, currentPage, limit);
  }, [searchKeyword, currentPage, limit]);

  const handleSearch = (keyword) => {
    setSearchKeyword(keyword);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  const handleView = (id) => {
    navigation(`view/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
          denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
          cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            setScreenLoading(true);
            await deleteTempTransaction(id);
            await fetchTempTransactionList(searchKeyword, currentPage, limit);
            swalWithBootstrapButtons.fire({
              title: 'Deleted!',
              text: 'Your file has been deleted.',
              icon: 'success',
            });
            setScreenLoading(false);
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
            });
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      setScreenLoading(false);
    }
  };

  const columnMap = {
    rtanggal: 'Date',
    rreferensi: 'Reference',
    rterang: 'Description',
    rjumlah: 'Amount',
    flag: 'Status',
    businessUnit: 'Business Unit',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  };

  return (
    <div>
      <LoadingOverlay
        show={screenLoading}
        message="Deleting transaction data..."
      />
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>
      <div className="card">
        <div className="card-body">
          <div className="table-search-new mb-2">
            <Search onSearch={handleSearch} />
            <div className=""></div>
            <Link className="btn btn-primary rounded-5" to="create">
              <i className="bi bi-plus-circle-dotted"></i>
              <span> New</span>
            </Link>
          </div>
          <Table
            items={tempTransaction}
            columnMap={columnMap}
            isLoading={isLoading}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            limit={limit}
            onView={handleView}
            onDelete={handleDelete}
            showViewButton={true} // Tampilkan tombol "view"
            showEditButton={false} // Sembunyikan tombol "edit"
          />
        </div>
      </div>
    </div>
  );
}

export default TempTransactionList;
